<template>
    <div class="app-logo">
        <router-link to="/">
            <span class="app-logo-icon"></span>
            <span class="app-logo-text">PMS</span>
        </router-link>
    </div>
</template>
<script>
    export default {
        data () {
            return {}
        },
        mounted () {

        },
        methods: {},
        computed: {}
    }
</script>
<style lang='less' scoped>
    .app-logo {
        padding: 0px 30px;
        line-height: 60px;
        height: 60px;
        overflow: hidden;
        white-space: nowrap;
        transition: padding .3s;
        background-color:#545c64;

        .app-logo-text {
            font-size: 20px;
            vertical-align: middle;
        }
        .app-logo-icon {
            background: url('../../assets/images/logo.png');
            background-size: contain;
            height: 26px;
            width: 26px;
            display: inline-block;
            margin-right: 10px;
            transition: .3s;
            vertical-align: middle;
            border-radius: 5px;
            overflow: hidden;
        }
    }
</style>
